import {ChangeDetectionStrategy, Component, Input, ViewEncapsulation} from '@angular/core';

@Component({
	standalone: false,
	selector       : '[app-ul]',
	template       : `
		<ng-container *ngIf="icons; else displayTextOnly">
			<li *ngFor="let item of items; let index = index">
				<i class="icon icon-{{icons[index]}}"></i>
				{{item}}
			</li>
		</ng-container>
		<ng-template #displayTextOnly>
			<li *ngFor="let item of items">{{item}}</li>
		</ng-template>
	`,
	encapsulation  : ViewEncapsulation.None,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UlComponent {
	@Input() items: Array<string | number> = [];

	@Input() icons: string[];
}